
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif","paint-order":"stroke fill markers"}},[_c('path',{attrs:{"d":"M2.055 0A2.068 1.968 0 000 1.957v14.087C0 17.115.93 18 2.056 18h13.888A2.068 1.968 0 0018 16.044V1.957C18 .885 17.07 0 15.943 0zm0 1.49h1.978c-.002.034-.004.07-.004.106v3.2c0 .837.722 1.524 1.6 1.524h6.373c.877 0 1.6-.687 1.6-1.523V1.596a1.76 1.76 0 00-.003-.107h2.344a.475.452 0 01.492.467v14.089a.475.452 0 01-.492.466h-1.258c.027-.12.042-.247.042-.375V9.49a1.856 1.766 0 00-1.85-1.76h-7.82a1.856 1.766 0 00-1.849 1.76v6.646c0 .128.015.254.042.375H2.055a.475.452 0 01-.49-.467V1.957a.475.452 0 01.49-.467zm2.99 0h4.8v3.873H5.63a.583.555 0 01-.595-.566V1.596a.559.532 0 01.01-.107zm5.806 0h1.735c.007.033.01.07.01.106v3.2a.582.554 0 01-.594.567h-1.15zM5.06 8.686h7.818c.477 0 .844.35.844.803v7.021H4.197l.017-7.021a.833.793 0 01.844-.803z","overflow":"visible"}}),_c('path',{attrs:{"d":"M15.547 15.19a.607.341 0 00-.401.09.757.426 0 00-.177.144 1.295.73 0 00-.11.311c0 .11.032.213.11.31a.554.527 0 00.177.144.607.341 0 00.4.09.607.341 0 00.401-.09.765.431 0 00.178-.144.513.488 0 00.11-.31.514.489 0 00-.11-.31.757.426 0 00-.178-.144.607.341 0 00-.4-.091zm-13.129 0a.607.341 0 00-.4.09.766.431 0 00-.18.144.506.482 0 00-.109.311.541.515 0 00.288.455.607.341 0 00.402.09.601.338 0 00.397-.09.772.435 0 00.18-.145.508.484 0 00.11-.31.515.49 0 00-.11-.31.766.431 0 00-.18-.144.601.34 0 00-.398-.091z","overflow":"visible"}})])])
          )
        }
      }
    